import { DarkMode, LightMode } from '@mui/icons-material'
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material'
import React from 'react'

const Navbar = ({theme,setTheme}) => {
  return (
    <Box>
      <AppBar position='sticky' sx={{backgroundColor:'darkblue'}}>
        <Toolbar sx={{display:'flex',justifyContent:'space-around',alignItems:'center'}}>
          <Typography variant='h6' sx={{textTransform:'uppercase'}}>Crypto Tracker</Typography>
          <IconButton sx={{color: theme === 'light' ? 'orangered' :'black',backgroundColor:'#cccccc'}} onClick={()=>setTheme(theme === 'light' ? 'dark' : 'light')}>
            {theme === 'light' ? <LightMode /> : <DarkMode />}
          </IconButton>
        </Toolbar>
      </AppBar>
    </Box>
  )
}

export default Navbar